import { useEffect, useRef, useState } from 'react';
import { Orbit } from 'lucide-react';

function WorkbenchMark() {
  const canvas = useRef(null);
  const [reducedMotion, setReducedMotion] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReducedMotion(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  useEffect(() => {
    if (reducedMotion) return;
    let disposed = false, release;
    const idle = setTimeout(() => {
      import('./workbenchScene.js').then(({ createWorkbenchScene }) => {
        if (disposed || !canvas.current) return;
        try { release = createWorkbenchScene(canvas.current); } catch { /* static mark remains available without WebGL */ }
      }).catch(() => { /* the composer remains independent from decorative assets */ });
    }, 350);
    return () => { disposed = true; clearTimeout(idle); release?.(); };
  }, [reducedMotion]);
  return <div className="workbench-mark" aria-hidden="true"><Orbit className="workbench-mark-fallback" strokeWidth={0.8} />{!reducedMotion && <canvas ref={canvas} />}</div>;
}

export default function WorkbenchWelcome({ code = false }) {
  return <div className="workbench-welcome">
    <WorkbenchMark />
    <span className="workbench-eyebrow">APOLO · SEU ESPAÇO DE TRABALHO</span>
    <h1>{code ? 'O que vamos desenvolver?' : 'O que você quer criar hoje?'}</h1>
    <p>{code ? 'Do projeto aberto ao código que funciona.' : 'Uma ideia, uma pergunta ou um projeto. Comece por aqui.'}</p>
  </div>;
}
